import { pipe } from 'ramda';
import React, { FC } from 'react';
import { DefaultEmptyTable } from 'components/organisms/template-insight/empty-state';
import { AccountFeature, useAccountFeature } from 'hooks/use-account-feature';
import { Content } from 'stores/core';
import { PageContentWrapper, WidgetContainer } from '../common';
import { ProjectsReport, ProjectsReportRecord } from '../types';
import {
  AverageProjectEndTime,
  AverageProjectStartTime,
  BudgetedVsTrackedHours,
  ProjectCompletedOnTime,
  ProjectStartedOnTime,
  useWidgetData,
} from '../widgets';
import { TimelineViewTable } from './table';

export const TimelineView: FC<{ projectsReport: ProjectsReport }> = ({
  projectsReport,
}) => {
  const records = pipe(
    () => projectsReport,
    Content.map((x) => x),
    Content.orElse([] as ProjectsReportRecord[]),
  )();

  const {
    averageProjectsStartingDelay,
    projectsStartedOnTime,
    averageProjectsEndingDelay,
    projectsEndedOnTime,
    averageHoursDifference,
  } = useWidgetData(projectsReport);

  const [isTimesheetFeatureEnabled] = useAccountFeature(
    AccountFeature.Timesheets,
  );

  return (
    <PageContentWrapper>
      <WidgetContainer xs={24} md={12} lg={6} xl={6} xxl={4}>
        <AverageProjectStartTime value={averageProjectsStartingDelay} />
        <ProjectStartedOnTime value={projectsStartedOnTime} />
        <AverageProjectEndTime value={averageProjectsEndingDelay} />
        <ProjectCompletedOnTime value={projectsEndedOnTime} />
        {isTimesheetFeatureEnabled ? (
          <BudgetedVsTrackedHours value={averageHoursDifference} />
        ) : null}
      </WidgetContainer>
      <TimelineViewTable
        projectsReportRecords={records}
        renderEmpty={() =>
          DefaultEmptyTable({
            noDataKey: 'reports.project_performance.no_reports.title',
          })
        }
      />
    </PageContentWrapper>
  );
};
